var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTitleMed1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3{fill:#66ddb3;}.cls-2{mix-blend-mode:screen;}.cls-3{opacity:0;}.cls-4{isolation:isolate;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 200,
    height: 200
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 12.76,
    y: 39.43,
    width: 173.58,
    height: 110.57,
    rx: 20.53,
    ry: 20.53
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M186.34,125.22v47.93c0,7.25-8.77,10.88-13.89,5.75l-53.51-53.51,67.4-.18Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 46.11,
    y: 63.88,
    width: 108.01,
    height: 20.55,
    rx: 10.28,
    ry: 10.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 46.11,
    y: 102.77,
    width: 68.13,
    height: 20.55,
    rx: 10.28,
    ry: 10.28
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitleMed1);
export default __webpack_public_path__ + "static/media/title-med-1.28ef55eb9693cefd1108972e8af759ef.svg";
export { ForwardRef as ReactComponent };